// extracted by mini-css-extract-plugin
export var accordionContent = "Accordion-module--accordionContent--0c88a";
export var accordionHeader = "Accordion-module--accordionHeader--fb7bc";
export var accordionRoot = "Accordion-module--accordionRoot--4bdde";
export var hide = "Accordion-module--hide--6ed97";
export var iconContainer = "Accordion-module--iconContainer--5576f";
export var rotate = "Accordion-module--rotate--25b7d";
export var show = "Accordion-module--show--6c79f";
export var uppercase = "Accordion-module--uppercase--469a3";